import Swiper from 'swiper';
import {Navigation, Pagination, Mousewheel, Autoplay} from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
    const sectionSliders = document.querySelectorAll('.section-slider .swiper');
    sectionSliders.forEach(function (slider) {
        let sliderSection = slider.closest('.section-slider');
        new Swiper(slider, {
            modules: [ Mousewheel, Autoplay],
            loop: true,
            slidesPerView: 1.5,
            simulateTouch: true,
            allowTouchMove: true,
            mousewheel: {
                forceToAxis: true
            },
            speed: 1000,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            spaceBetween: 16,
            breakpoints: {
                768: {
                    slidesPerView: 2.5,
                },
                1024: {
                    slidesPerView: 4.5,
                },
                1600: {
                    slidesPerView: 5.5,
                }
            }
        });
    });
});
